import React, { Component } from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom"

import { doGetPayment, doFetchProductAddon, doGetBankAccounts } from '../../actions/paymentAction';
import { doChangeCategory } from '../../actions/categoryAction';
import DetailSection from './Detail';
import RedirectIfUnauthentic from '../RedirectIfUnauthentic';
import { Redirect } from 'react-router-dom';
import { getQueryParamsUrl } from '../../helpers/url'

import ModalPaymentConfirmation from '../Modals/ModalPaymentConfirmation';
import { doFetchCurrencyRate } from '../../actions/authAction';
import { CURRENCY_CODE } from '../../constants';
class PageInvoice extends Component {
  constructor(props) {
    super(props);
    const params = Object.assign({ trxId: null }, getQueryParamsUrl(props.location.search));
    this.state = {
      invoice: this.props.match.params.invoice,
      product: null,
      sell: null,
      payment: null,
      error: null,
      paymentFetched: false,
      params,
      addOnProduct: [],
      isModalConfirmationOpened: false,
      fetchedCurrency: false
    }
    this._redirectToPaymentConfirmation = this._redirectToPaymentConfirmation.bind(this);
    this.goToBuyingDashboard = this.goToBuyingDashboard.bind(this);
    this.toggleModalPayemntConfirmation = this.toggleModalPayemntConfirmation.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.dataPayment.paymentDetail.isFetch && !this.props.dataPayment.paymentDetail.isFetch) {
      if (this.props.dataPayment.paymentDetail.status_code === 200) {
        const { data } = this.props.dataPayment.paymentDetail;
        const { user_sell, ...payment } = data;
        const { product_variant, ...sell } = user_sell;
        let type = 'transfer';
        if (payment.invoice_url !== null) {
          if (payment.payment_method === 'virtual_account' || payment.payment_method === 'credit_card') {
            type = payment.payment_via === 'xnd' ? 'xendit' : payment.payment_via === 'spa' ? "sprint_asia" : 'midtrans';
          }
          else if (payment.payment_method === 'kredivo')
            type = 'kredivo';
          else type = payment.payment_method;
        }
        else if (payment.payment_method === 'full_wallet') {
          type = 'kickwallet';
        }
        this.setState({
          product: product_variant,
          sell,
          payment,
          paymentFetched: true,
          type
        }, () => {
          const { product: { product } } = this.state;
          const { dataCategory } = this.props;
          if (product.category && product.category.name.toLowerCase() !== dataCategory) {
            switch (product.category.name.toLowerCase()) {
              case "apparels": this.props.doChangeCategory('apparels'); break;
              default: this.props.doChangeCategory('sneakers'); break;
            }
          }
        })
      }
      else {
        const { error } = this.props.dataPayment.paymentDetail;
        this.setState({
          error
        })
      }
    }

    if (prevProps.productAddon !== this.props.productAddon && this.props.productAddon.data && this.props.productAddon.data.length > 0) {
      const { data } = this.props.productAddon || {}
      this.setState({
        addOnProduct: data
      })
    }

    if (this.props.dataAuth.userdata.country_code && !this.state.fetchedCurrency) {
      try {
        const countryCode = this.props.dataAuth.userdata.country_code
        const currencyCode = CURRENCY_CODE[countryCode === 'IDN' ? 'IDN' : 'ETC']
        this.props.doFetchCurrencyRate(currencyCode);
      } catch (error) {
        this.props.doFetchCurrencyRate(CURRENCY_CODE['IDN'])
      }
      this.setState({ fetchedCurrency: true })
    }
  }

  componentDidMount() {
    this.props.getPaymentDetail(this.state.invoice)
    this.props.doFetchProductAddon()
    this.props.getBankAccountList()
  }

  toggleModalPayemntConfirmation() {
    this.setState({
      isModalConfirmationOpened: !this.state.isModalConfirmationOpened
    })
  }

  _redirectToPaymentConfirmation(e = null) {
    // if(e)e.preventDefault();

    if (this.state.payment !== null) {
      const { invoice_url } = this.state.payment;
      if (invoice_url) window.location = invoice_url;
      else {
        // let pathname = '/payment_confirmation';
        // pathname = `${pathname}/${this.state.payment.invoice_number}`;
        // this.props.history.replace({ pathname });
        this.toggleModalPayemntConfirmation()
      }
    }
  }

  goToBuyingDashboard() {
    this.props.history.push("/user_dashboard/order")
  }

  render() {
    // if (window.innerWidth <= 768)
    if (this.state.error !== null && this.state.error.status_code === 404)
      return <Redirect to="/404" />
    return (
      <div className={"page-container product-selected product-container " + this.props.countdown_timer ? 'is-countdown-active' : ''} id="invoice-container">
        <RedirectIfUnauthentic
          isAuthentic={this.props.dataAuth.isLogged}
          isLoading={this.props.dataAuth.userdata.isFetch}
          from={this.props.location}
        />
        {
          !this.state.paymentFetched ?
            null :
            <DetailSection
              userCurrency={this.props.dataAuth.userCurrency}
              trxTkn={this.state.params.trxId}
              payment={this.state.payment}
              sell={this.state.sell}
              product={this.state.product}
              onActionClick={this._redirectToPaymentConfirmation}
              type={this.state.type}
              addOnProduct={this.state.addOnProduct}
              goToBuyingDashboard={this.goToBuyingDashboard}
              history={this.props.history}
              isLoading={this.props?.dataPayment?.paymentDetail?.isFetch}
            />
        }
        {
          <ModalPaymentConfirmation
            isOpen={this.state.isModalConfirmationOpened}
            onToggle={this.toggleModalPayemntConfirmation}
            paymentInfo={{
              invoiceNumber: '',
              transferAmount: 0,
            }}
            callback={this.toggleModalPayemntConfirmation}
          />
        }
      </div>
    )
  }
}

const mapStateToProps = state => ({
  dataAuth: state.dataAuth,
  dataPayment: state.dataPayment,
  dataCategory: state.dataCategory.selected,
  productAddon: state.dataPayment.productAddon,
  bankAccounts: state.dataPayment.bankAccounts,
  countdown_timer: state.dataMenu.countdown_modal,
})
const mapDispatchToProps = dispatch => ({
  getPaymentDetail: invoice => dispatch(doGetPayment(invoice)),
  doChangeCategory: category => dispatch(doChangeCategory(category)),
  doFetchProductAddon: (payload) => dispatch(doFetchProductAddon(payload)),
  getBankAccountList: () => dispatch(doGetBankAccounts()),
  handleShowFooter: (payload) => dispatch(handleShowFooter(payload)),
  doFetchCurrencyRate: (payload) => dispatch(doFetchCurrencyRate(payload)),
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PageInvoice))
